import { useEffect, useState } from "react";
import "./GlTransactions.scss";
import { useSelector } from "react-redux";
import newRequest from "../../../utils/newRequest";
import { ScaleLoader } from "react-spinners";
import { IoClose } from "react-icons/io5";
import { FiSearch } from "react-icons/fi";
import { motion } from "framer-motion";
import { CustomLoadingButton } from "../../../components/ui/CustomButton";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import {
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    Table,
    TableContainer,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    TablePagination,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import Taccount from "../../../components/taccount/Taccount";
import { MdClose } from "react-icons/md";
import { logData } from "../../../utils/genericFunctions";

const GlTransactions = () => {
    const { t } = useTranslation();
    const { currentTheme } = useSelector((state) => state.theme);
    const { currentUser } = useSelector((state) => state.user);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [transactions, setTransactions] = useState([]);
    const [selectedTransaction, setSelectedTransaction] = useState(null);

    const [rowsPerPage, setRowsPerPage] = useState(8);
    const [currentTranPage, setCurrentTranPage] = useState(0);

    const fetchTransactions = async (firstTime = false) => {
        try {
            if (firstTime) {
                setIsLoading(true);
            } else {
                setIsProcessing(true);
            }
            // Simulate delay for 5 seconds
            // await new Promise((resolve) => setTimeout(resolve, 5000));
            const res = await newRequest.post("/gl/getgl", { search_input: "", days: 30 });
            // logData("trans", res.data);
            setTransactions(res.data);
            setSelectedTransaction(res.data[0]);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            if (firstTime) {
                setIsLoading(false);
            } else {
                setIsProcessing(false);
            }
        }
    };

    const handleSearchTransactions = async () => {
        try {
            setIsLoading(true);
            setSelectedTransaction(null);
            if (searchTerm) {
                const res = await newRequest.post("/gl/getgl", { search_input: searchTerm, days: 30 });
                setTransactions(res.data);
            } else {
                fetchTransactions(false);
            }
        } catch (error) {
            console.error("Error searching data:", error);
        } finally {
            setIsLoading(false);
        }
    };


    const handleTranPageChange = (event, newPage) => {
        setCurrentTranPage(newPage);
    };

    const handleTranRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 8));
        setCurrentTranPage(0);
    };


    const filteredTrans = transactions?.filter(
        (row) =>
            row?.trn_original_docno?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row?.trn_doc_type?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const paginatedTrans = filteredTrans?.slice(
        currentTranPage * rowsPerPage,
        currentTranPage * rowsPerPage + rowsPerPage
    );

    useEffect(() => {
        fetchTransactions(true);
    }, []);


    return (
        <div className='gl-transactions'>
            {isLoading ? (
                <div className="no-content">
                    <ScaleLoader
                        color="var(--primary)"
                        height={50}
                        radius={8}
                        width={4}
                    />
                </div>
            ) : (
                <motion.div
                    className="gl-transactions-main-wrapper"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}>
                    <div className="gl-transactions-center-wrapper">
                        <div className="center-content">
                            {selectedTransaction && <Taccount key={selectedTransaction?.trn_original_docno} originalDocno={selectedTransaction?.trn_original_docno} originalDocType={selectedTransaction?.trn_doc_type} />}
                        </div>
                    </div>
                    <div className="gl-transactions-right-wrapper">
                        <div className="homeSearch" style={{ width: "95%" }}>
                            <FiSearch className="homeSearchIcon" />
                            <input
                                className="homeSearchInput"
                                type="text"
                                placeholder={t('search')}
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') handleSearchTransactions();
                                }}
                            />
                            {searchTerm?.length > 0 ? (
                                <MdClose
                                    className="homeSearchClear"
                                    onClick={async () => {
                                        try {
                                            await fetchTransactions(false);
                                            setSearchTerm("");
                                        } catch (error) {
                                            console.log(error);
                                        }
                                    }}
                                />
                            ) : (
                                <span className="homeSearchClearPlaceholder" />
                            )}
                        </div>
                        <div className="table-content" style={{ width: "95%" }}>
                            <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                <Table sx={{ width: "max-content", border: 'none' }}>
                                    <TableBody className="tablebody">
                                        {paginatedTrans?.map((row, index) => (
                                            <TableRow
                                                key={row.hash_key}
                                                style={{ padding: "5px" }}
                                                className={`${selectedTransaction?.hash_key === row.hash_key ? "tablerow current" : "tablerow"}`}
                                                onClick={() => setSelectedTransaction(row)}
                                            >
                                                <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                    <div style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center", justifyContent: "space-between", marginBottom: "5px" }}>
                                                        <span className="sub-title">{row?.trn_original_docno}</span>
                                                        <span className="sub-title">{row?.trn_doc_type}</span>
                                                    </div>
                                                    <div style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center", justifyContent: "space-between" }}>
                                                        <span className="sub-title xrsmall" style={{ color: "red" }}>{row?.trn_cur_code}</span>
                                                        <span className="sub-title xrsmall">{row?.formatted_gl_date}</span>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                {transactions?.length > rowsPerPage &&
                                    <TablePagination
                                        rowsPerPageOptions={[8]}
                                        rowsPerPage={rowsPerPage}
                                        onRowsPerPageChange={handleTranRowsPerPage}
                                        component="div"
                                        count={transactions?.length}
                                        rows={transactions}
                                        page={currentTranPage}
                                        onPageChange={handleTranPageChange}
                                    />}
                            </TableContainer>
                        </div>
                    </div>
                </motion.div>
            )}   </div>
    )
}



export default GlTransactions;